import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PatientReferralForm from './components/PatientReferralForm';
import DoctorDashboard     from './components/DoctorDashboard';
import DeskDashboard       from './components/DeskDashboard';
import LoginPage           from './components/LoginPage';
import AcceptInvitePage    from './components/AcceptInvitePage';
import ProtectedRoute      from './components/ProtectedRoute';
import PaymentForm         from './components/PaymentForm';
import SmilePreview        from './components/SmilePreview';
import './index.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/"                       element={<PatientReferralForm />} />
        <Route path="/payment"                element={<PaymentForm />} />
        <Route path="/smile-preview"          element={<SmilePreview />} />
        <Route path="/embed/smile-preview"    element={<SmilePreview isEmbed={true} />} />
        <Route path="/embed"                  element={<SmilePreview isEmbed={true} />} />
        <Route path="/login"                  element={<LoginPage />} />
        <Route path="/accept-invite/:token"   element={<AcceptInvitePage />} />

        {/* Protected — Desk */}
        <Route path="/desk" element={
          <ProtectedRoute allowedRoles={['desk']}>
            <DeskDashboard />
          </ProtectedRoute>
        } />

        {/* Protected — Doctor */}
        <Route path="/doctor" element={
          <ProtectedRoute allowedRoles={['doctor']}>
            <DoctorDashboard />
          </ProtectedRoute>
        } />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;